import React from "react";
import "../css/Footer.css";
const Footer = () => {
  return (
    <footer>
      <p className="f-p">Created by® Beyram Jouini and Mohamed Ali Mosrati</p>
    </footer>
  );
};

export default Footer;
